export default [
  {
    'city': 'Afghanistan',
    'code': '+93'
  },
  {
    'city': 'Albania',
    'code': '+355'
  },
  {
    'city': 'Algeria  ',
    'code': '+213'
  },
  {
    'city': 'American Samoa',
    'code': '+1'
  },
  {
    'city': 'Andorra',
    'code': '+376'
  },
  {
    'city': 'Angola',
    'code': '+244'
  },
  {
    'city': 'Anguilla',
    'code': '+1'
  },
  {
    'city': 'Antigua and Barbuda',
    'code': '+1'
  },
  {
    'city': 'Argentina',
    'code': '+54'
  },
  {
    'city': 'Armenia',
    'code': '+374'
  },
  {
    'city': 'Aruba',
    'code': '+297'
  },
  {
    'city': 'Australia',
    'code': '+61'
  },
  {
    'city': 'Austria',
    'code': '+43'
  },
  {
    'city': 'Azerbaijan',
    'code': '+994'
  },
  {
    'city': 'Bahamas',
    'code': '+1'
  },
  {
    'city': 'Bahrain',
    'code': '+973'
  },
  {
    'city': 'Bangladesh',
    'code': '+880'
  },
  {
    'city': 'Barbados',
    'code': '+1'
  },
  {
    'city': 'Belarus',
    'code': '+375'
  },
  {
    'city': 'Belgium',
    'code': '+32'
  },
  {
    'city': 'Belize',
    'code': '+501'
  },
  {
    'city': 'Benin',
    'code': '+229'
  },
  {
    'city': 'Bermuda',
    'code': '+1'
  },
  {
    'city': 'Bhutan',
    'code': '+975'
  },
  {
    'city': 'Bolivia',
    'code': '+591'
  },
  {
    'city': 'Bosnia and Herzegovina',
    'code': '+387'
  },
  {
    'city': 'Botswana',
    'code': '+267'
  },
  {
    'city': 'Brazil',
    'code': '+55'
  },
  {
    'city': 'Brunei',
    'code': '+673'
  },
  {
    'city': 'Bulgaria',
    'code': '+359'
  },
  {
    'city': 'Burkina Faso',
    'code': '+226'
  },
  {
    'city': 'Burundi',
    'code': '+257'
  },
  {
    'city': 'Cambodia',
    'code': '+855'
  },
  {
    'city': 'Cameroon',
    'code': '+237'
  },
  {
    'city': 'Canada',
    'code': '+1'
  },
  {
    'city': 'Cape Verde',
    'code': '+238'
  },
  {
    'city': 'Cayman Islands',
    'code': '+1345'
  },
  {
    'city': 'Central Africa',
    'code': '+236'
  },
  {
    'city': 'Chad',
    'code': '+235'
  },
  {
    'city': 'Chile',
    'code': '+56'
  },
  {
    'city': 'China',
    'code': '+86'
  },
  {
    'city': 'Colombia',
    'code': '+57'
  },
  {
    'city': 'Comoros',
    'code': '+269'
  },
  {
    'city': 'Congo',
    'code': '+242'
  },
  {
    'city': 'Cook Islands',
    'code': '+682'
  },
  {
    'city': 'Costa Rica',
    'code': '+506'
  },
  {
    'city': 'Croatia',
    'code': '+385'
  },
  {
    'city': 'Cuba',
    'code': '+53'
  },
  {
    'city': 'Cyprus',
    'code': '+357'
  },
  {
    'city': 'Czech Republic',
    'code': '+420'
  },
  {
    'city': 'DR Congo',
    'code': '+243'
  },
  {
    'city': 'Denmark',
    'code': '+45'
  },
  {
    'city': 'Djibouti',
    'code': '+253'
  },
  {
    'city': 'Dominica',
    'code': '+1767'
  },
  {
    'city': 'Dominican Republic',
    'code': '+1829'
  },
  {
    'city': 'East Timor',
    'code': '+670'
  },
  {
    'city': 'Ecuador',
    'code': '+593'
  },
  {
    'city': 'Egypt',
    'code': '+20'
  },
  {
    'city': 'El Salvador',
    'code': '+503'
  },
  {
    'city': 'Equatorial Guinea',
    'code': '+240'
  },
  {
    'city': 'Eritrea',
    'code': '+Estonia'
  },
  {
    'city': 'Ethiopia',
    'code': '+251'
  },
  {
    'city': 'Falkland Islands',
    'code': '+500'
  },
  {
    'city': 'Faroe Islands',
    'code': '+298'
  },
  {
    'city': 'Fiji',
    'code': '+679'
  },
  {
    'city': 'Finland',
    'code': '+358'
  },
  {
    'city': 'France',
    'code': '+33'
  },
  {
    'city': 'French Guiana',
    'code': '+594'
  },
  {
    'city': 'French Polynesia',
    'code': '+689'
  },
  {
    'city': 'Gabon',
    'code': '+241'
  },
  {
    'city': 'Gambia',
    'code': '+220'
  },
  {
    'city': 'Georgia',
    'code': '+995'
  },
  {
    'city': '德国',
    'code': '+94'
  },
  {
    'city': '加纳',
    'code': '+233'
  },
  {
    'city': '直布罗陀',
    'code': '+350'
  },
  {
    'city': '希腊',
    'code': '+30'
  },
  {
    'city': '格陵兰',
    'code': '+299'
  },
  {
    'city': '格林纳达',
    'code': '+1473'
  },
  {
    'city': '瓜德罗普',
    'code': '+590'
  },
  {
    'city': '关岛',
    'code': '+1671'
  },
  {
    'city': '危地马拉',
    'code': '+502'
  },
  {
    'city': '根西',
    'code': '+44'
  },
  {
    'city': '几内亚',
    'code': '+224'
  },
  {
    'city': 'Guinea-Bissau',
    'code': '+245'
  },
  {
    'city': '圭亚那',
    'code': '+592'
  },
  {
    'city': '海地',
    'code': '+509'
  },
  {
    'city': '洪都拉斯',
    'code': '+504'
  },
  {
    'city': 'Hong Kong',
    'code': '+852'
  },
  {
    'city': '匈牙利',
    'code': '+36'
  },
  {
    'city': '冰岛',
    'code': '+354'
  },
  {
    'city': '印度',
    'code': '+91'
  },
  {
    'city': '印度尼西亚',
    'code': '+62'
  },
  {
    'city': '伊朗',
    'code': '+98'
  },
  {
    'city': '伊拉克',
    'code': '+964'
  },
  {
    'city': '爱尔兰',
    'code': '+353'
  },
  {
    'city': '马恩岛',
    'code': '+44'
  },
  {
    'city': '以色列',
    'code': '+972'
  },
  {
    'city': '意大利',
    'code': '+39'
  },
  {
    'city': 'Ivory Coast',
    'code': '+225'
  },
  {
    'city': '牙买加',
    'code': '+1876'
  },
  {
    'city': '日本',
    'code': '+81'
  },
  {
    'city': '泽西岛',
    'code': '+44'
  },
  {
    'city': '约旦',
    'code': '+962'
  },
  {
    'city': '哈萨克斯坦',
    'code': '+7'
  },
  {
    'city': '肯尼亚',
    'code': '+254'
  },
  {
    'city': 'Kiribati',
    'code': '+686'
  },
  {
    'city': 'Korea Republic of',
    'code': '+82'
  },
  {
    'city': 'Kosovo',
    'code': '+381'
  },
  {
    'city': '科威特',
    'code': '+965'
  },
  {
    'city': '吉尔吉斯斯坦',
    'code': '+996'
  },
  {
    'city': '老挝',
    'code': '+856'
  },
  {
    'city': '拉脱维亚',
    'code': '+371'
  },
  {
    'city': '黎巴嫩',
    'code': '+961'
  },
  {
    'city': '莱索托',
    'code': '+266'
  },
  {
    'city': '利比里亚',
    'code': '+231'
  },
  {
    'city': '利比亚',
    'code': '+218'
  },
  {
    'city': '列支敦士登',
    'code': '+423'
  },
  {
    'city': '立陶宛',
    'code': '+370'
  },
  {
    'city': '卢森堡',
    'code': '+352'
  },
  {
    'city': 'Macau',
    'code': '+853'
  },
  {
    'city': '马其顿',
    'code': '+389'
  },
  {
    'city': '马达加斯加',
    'code': '+261'
  },
  {
    'city': '马拉维',
    'code': '+265'
  },
  {
    'city': '马来西亚',
    'code': '+60'
  },
  {
    'city': '马尔代夫',
    'code': '+960'
  },
  {
    'city': '马里',
    'code': '+223'
  },
  {
    'city': '马耳他',
    'code': '+356'
  },
  {
    'city': 'Islands',
    'code': '+692'
  },
  {
    'city': '马提尼克',
    'code': '+596'
  },
  {
    'city': '毛里塔尼亚',
    'code': '+222'
  },
  {
    'city': '毛里求斯',
    'code': '+230'
  },
  {
    'city': '墨西哥',
    'code': '+52'
  },
  {
    'city': 'Micronesia',
    'code': '+691'
  },
  {
    'city': '摩尔多瓦',
    'code': '+373'
  },
  {
    'city': '摩纳哥',
    'code': '+377'
  },
  {
    'city': '蒙古',
    'code': '+976'
  },
  {
    'city': '黑山',
    'code': '+382'
  },
  {
    'city': '蒙特塞拉特',
    'code': '+1664'
  },
  {
    'city': '摩洛哥',
    'code': '+212'
  },
  {
    'city': '莫桑比克',
    'code': '+258'
  },
  {
    'city': 'Myanmar',
    'code': '+95'
  },
  {
    'city': '纳米比亚',
    'code': '+264'
  },
  {
    'city': '尼泊尔',
    'code': '+977'
  },
  {
    'city': '荷兰',
    'code': '+31'
  },
  {
    'city': '荷属安的列斯',
    'code': '+599'
  },
  {
    'city': '新喀里多尼亚',
    'code': '+687'
  },
  {
    'city': '新西兰',
    'code': '+64'
  },
  {
    'city': '尼加拉瓜',
    'code': '+505'
  },
  {
    'city': '尼日尔',
    'code': '+227'
  },
  {
    'city': '尼日利亚',
    'code': '+234'
  },
  {
    'city': 'Niue',
    'code': '+683'
  },
  {
    'city': 'Norfolk Island',
    'code': '+672'
  },
  {
    'city': '挪威',
    'code': '+47'
  },
  {
    'city': '阿曼',
    'code': '+968'
  },
  {
    'city': '巴基斯坦',
    'code': '+92'
  },
  {
    'city': 'Palau',
    'code': '+680'
  },
  {
    'city': '巴勒斯坦',
    'code': '+970'
  },
  {
    'city': '巴拿马',
    'code': '+507'
  },
  {
    'city': '巴布亚新几内亚',
    'code': '+675'
  },
  {
    'city': '巴拉圭',
    'code': '+595'
  },
  {
    'city': '秘鲁',
    'code': '+51'
  },
  {
    'city': '菲律宾',
    'code': '+63'
  },
  {
    'city': '波兰',
    'code': '+48'
  },
  {
    'city': '葡萄牙',
    'code': '+351'
  },
  {
    'city': '波多黎各',
    'code': '+1'
  },
  {
    'city': '库塔',
    'code': '+974'
  },
  {
    'city': '留尼汪',
    'code': '+262'
  },
  {
    'city': '罗马尼亚',
    'code': '+40'
  },
  {
    'city': '俄罗斯',
    'code': '+7'
  },
  {
    'city': '卢旺达',
    'code': '+250'
  },
  {
    'city': '萨摩亚东部',
    'code': '+684'
  },
  {
    'city': '萨摩亚西部',
    'code': '+685'
  },
  {
    'city': '圣马力诺',
    'code': '+378'
  },
  {
    'city': '圣多美和普林西比',
    'code': '+239'
  },
  {
    'city': '沙特阿拉伯',
    'code': '+966'
  },
  {
    'city': '塞内加尔',
    'code': '+221'
  },
  {
    'city': '塞尔维亚',
    'code': '+381'
  },
  {
    'city': '塞舌尔',
    'code': '+248'
  },
  {
    'city': '塞拉利昂',
    'code': '+232'
  },
  {
    'city': 'Singapore',
    'code': '+65'
  },
  {
    'city': '斯洛伐克',
    'code': '+421'
  },
  {
    'city': '斯洛文尼亚',
    'code': '+386'
  },
  {
    'city': 'Solomon Islands',
    'code': '+677'
  },
  {
    'city': 'Somalia',
    'code': '+252'
  },
  {
    'city': '南非',
    'code': '+27'
  },
  {
    'city': 'South Sudan',
    'code': '+211'
  },
  {
    'city': '西班牙',
    'code': '+34'
  },
  {
    'city': '斯里兰卡',
    'code': '+94'
  },
  {
    'city': '圣基茨和尼维斯',
    'code': '+1869'
  },
  {
    'city': '圣卢西亚',
    'code': '+1758'
  },
  {
    'city': 'St Pierre and Miquelon',
    'code': '+508'
  },
  {
    'city': '圣文森特',
    'code': '+1784'
  },
  {
    'city': '苏丹',
    'code': '+249'
  },
  {
    'city': '苏里南',
    'code': '+597'
  },
  {
    'city': '斯威士兰',
    'code': '+268'
  },
  {
    'city': '瑞典',
    'code': '+46'
  },
  {
    'city': '瑞士',
    'code': '+41'
  },
  {
    'city': '叙利亚',
    'code': '+963'
  },
  {
    'city': 'Taiwan',
    'code': '+886'
  },
  {
    'city': '塔吉克斯坦',
    'code': '+992'
  },
  {
    'city': '坦桑尼亚',
    'code': '+255'
  },
  {
    'city': '泰国',
    'code': '+66'
  },
  {
    'city': 'Togo',
    'code': '+228'
  },
  {
    'city': '汤加',
    'code': '+676'
  },
  {
    'city': '特立尼达和多巴哥',
    'code': '+1868'
  },
  {
    'city': '突尼斯',
    'code': '+216'
  },
  {
    'city': '土耳其',
    'code': '+90'
  },
  {
    'city': '土库曼斯坦',
    'code': '+993'
  },
  {
    'city': '特克斯和凯科斯群岛',
    'code': '+1649'
  },
  {
    'city': '乌干达',
    'code': '+256'
  },
  {
    'city': '乌克兰',
    'code': '+380'
  },
  {
    'city': '阿拉伯联合酋长国',
    'code': '+971'
  },
  {
    'city': '英国',
    'code': '+44'
  },
  {
    'city': '美国',
    'code': '+1'
  },
  {
    'city': '乌拉圭',
    'code': '+598'
  },
  {
    'city': '乌兹别克斯坦',
    'code': '+998'
  },
  {
    'city': '瓦努阿图',
    'code': '+678'
  },
  {
    'city': '委内瑞拉',
    'code': '+58'
  },
  {
    'city': '越南',
    'code': '+84'
  },
  {
    'city': 'Virgin Islands, British',
    'code': '+1284'
  },
  {
    'city': '维尔京群岛',
    'code': '+1340'
  },
  {
    'city': '也门',
    'code': '+967'
  },
  {
    'city': '赞比亚',
    'code': '+260'
  },
  {
    'city': '津巴布韦',
    'code': '+263'
  },
  {
    'city': 'estonia',
    'code': '+372'
  },
  {
    'city': 'Germany',
    'code': '+49'
  }
]
